'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _Error = require('components/Errors/Error404');

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Errors
 *
 */
exports.default = (0, _reactRedux.connect)()(_Error2.default);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Errors.js
// module id = 346
// module chunks = 1